<template>
  <v-row class="fill-height">
    <v-col cols="11" lg="7" class="fill-height pa-10">
      <h1 class="primary--text" v-html="$t('about.title')">{{ $t('about.title') }}</h1>
      <p class="text-body-1" v-html="$t('about.first_paragraph')">{{ $t('about.first_paragraph') }}</p>
      <p class="text-body-1" v-html="$t('about.second_paragraph')">{{ $t('about.second_paragraph') }}</p>
      <p class="text-body-1" v-html="$t('about.goal_paragraph')">{{ $t('about.goal_paragraph') }}</p>
      <p class="title" v-html="$t('about.values_paragraph.title')">{{ $t('about.values_paragraph.title') }}</p>
      <p class="text-left" v-html="$t('about.values_paragraph.first')">{{ $t('about.values_paragraph.first') }}</p>
      <p class="text-left" v-html="$t('about.values_paragraph.second')">{{ $t('about.values_paragraph.second') }}</p>
      <p class="text-left" v-html="$t('about.values_paragraph.third')">{{ $t('about.values_paragraph.third') }}</p>
    </v-col>
    <template v-if="!$vuetify.breakpoint.mobile">
      <v-col lg="5" class="d-flex justify-center align-center pa-lg-12 nitg__quote-container">
        <quotes-component/>
      </v-col>
    </template>
  </v-row>
</template>

<script>
    export default {
        name: "About"
    }
</script>

<style scoped>

</style>
